import vm from '@/main'

export default function (apiClient) {
  apiClient.interceptors.response.use(response => response, error => {
    let detail = error.response?.data?.error?.detail

    if (detail) {
      if (typeof detail === 'string') {
        vm.$notify({
          message: detail,
          type: 'danger'
        })
      } else {
        Object.keys(detail).forEach(key => {
          detail[key].forEach(message => {
            vm.$notify({
              message: message,
              type: 'danger'
            })
          })
        })
      }
    } else {
      vm.$notify({
        message: error.response.statusText,
        type: 'danger'
      })
    }

    return Promise.reject(error)
  })
}
